import { type MutationTree } from 'vuex';

import { type AgreementRelationTypesState, type RelationshipData, type RelationshipType } from './types';

export const RETRIEVE_RELATIONSHIP_TYPE = 'retrieveRelationshipType';

export const mutations: MutationTree<AgreementRelationTypesState> = {
    [RETRIEVE_RELATIONSHIP_TYPE](_state: AgreementRelationTypesState, { responseData }: { responseData: RelationshipData }) {
        const data = Object.entries(responseData);
        const newRelationshipOptions: RelationshipType[] = data.map(([key, val]) => {
            return { label: val, value: key };
        });

        _state.agreementRelationshipTypes = [...newRelationshipOptions];
    }
};
